export const Theme = {
    cores: {
        primaria: '#154366',//'#333c4d', // Substitua com a cor desejada
    },
};

export interface ThemeInterface {
    cores: {
      primaria: string;
      // outras propriedades de cores
    };
    // outras propriedades do tema
  }